var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199.4 199.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.1;}.cls-2{fill:#00adf0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 99.7,
    cy: 99.7,
    r: 99.7
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.1,129.9H105.4V112.1h5.8a1.86,1.86,0,0,0,1.5-2.9L101.4,93.5a1.78,1.78,0,0,0-2.9,0L87.2,109.2a1.83,1.83,0,0,0,1.5,2.9h5.8v17.8H74.8C66,129.4,59,121.1,59,112.2a16.52,16.52,0,0,1,8.3-14.4,10,10,0,0,1-.7-3.9A11.39,11.39,0,0,1,78,82.5a10,10,0,0,1,3.9.7,22.72,22.72,0,0,1,43.2,7.5c9.1,1.6,16,10,16,19.5C141,120.4,133.1,129.2,123.1,129.9Z",
    transform: "translate(-0.3 -0.3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/upload-file-icon.1a2643743fb490ec23deb965c67d8933.svg";
export { ForwardRef as ReactComponent };